import { Table } from 'react-bootstrap';

const AuditLogTable = ({ logs }) => {
  return (
    <>
      <h5>Recent Audit Logs</h5>
      <Table bordered hover size="sm">
        <thead className="table-light">
          <tr>
            <th>Time</th>
            <th>User</th>
            <th>Action</th>
            <th>Tenant</th>
            <th>Entity</th>
          </tr>
        </thead>
        <tbody>
          {logs.map(log => (
            <tr key={log.id}>
              <td>{new Date(log.timestamp).toLocaleString()}</td>
              <td>{log.user_id || 'System'}</td>
              <td>{log.action}</td>
              <td>{log.tenant_id || '-'}</td>
              <td>{log.entity_type || '-'}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  );
};

export default AuditLogTable;
